var React = require('react');

function Vimeo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 7.557L2.117 8.917C2.117 8.917 3.487 7.275 4.347 8.006C6.37 9.72 7.253 21.5 10.953 21.5C13.918 21.5 23 12.876 23 6.722C23 3.946 21.864 2.5 19.333 2.5C16.803 2.5 14.171 4.161 13.619 7.498C16.132 5.978 17.496 8.151 16.334 10.553C15.173 12.955 13.971 14.533 13.117 14.533C10.731 14.533 12.497 2.5 7.81 2.5C5.006 2.5 1 7.557 1 7.557Z","fill":"#FCFCFC"}));
}

Vimeo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Vimeo;

Vimeo.default = Vimeo;
